import FormControls from "library/Molecules/FormControls";
import useNewOrderMachine from "pages/NewOrder/hooks/useNewOrderMachine";
import { PropTypes } from "prop-types";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { NEW_ORDER_FORM_STEPS } from "../../../../constants";

const NewOrderSubmitButtons = ({ onReset, onSubmit, resetBtnOptions, submitBtnOptions }) => {
  const { t } = useTranslation();

  const [, { step }] = useNewOrderMachine();

  const submitBtnLabel = useMemo(() => {
    switch (step) {
      case NEW_ORDER_FORM_STEPS.SET_DELIVERY:
        return "newOrder.forms.setDeliveryForm.calculateBtn";
      case NEW_ORDER_FORM_STEPS.CALCULATE:
        return "newOrder.forms.calculatePriceForm.continueBtn";
      default:
        return "newOrder.forms.bookingForm.sendBookingBtn";
    }
  }, [step]);

  return (
    <FormControls
      className="mt-5"
      resetBtnOptions={{
        id: "reset-new-order-form-button",
        label: t("common.buttons.resetBtn"),
        onClick: onReset,
        ...resetBtnOptions,
      }}
      submitBtnsOptions={{
        id: "submit-new-order-step-button",
        label: t(submitBtnLabel),
        onClick: onSubmit,
        ...submitBtnOptions,
      }}
    />
  );
};

NewOrderSubmitButtons.defaultProps = {
  submitBtnOptions: {},
  resetBtnOptions: {},
};

NewOrderSubmitButtons.propTypes = {
  onReset: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  resetBtnOptions: PropTypes.shape({
    disabled: PropTypes.bool,
    loading: PropTypes.func,
  }),
  submitBtnOptions: PropTypes.shape({
    disabled: PropTypes.bool,
    loading: PropTypes.bool,
  }),
};

export default NewOrderSubmitButtons;
